<script>
import i18n from "../i18n";
import NotificationsApi from "@/services/notifications-api";
import simplebar from "simplebar-vue";
import SupplierApi from "@/services/suppliers-api";
import PaymentStoryModal from "@/components/PaymentStoryModal.vue";


/**
 * Nav-bar Component
 */
export default {
  computed: {
    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },
    
    messageNotifPagesNbr() {
      return Math.ceil(this.messageNotificationsCount / this.messageNotifPageSize);
    },
  },
  data() {
    return {
      languages: [
        {
          language: "fr",
          title: "French",
        },
      ],
            lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      userFullName: '',
      userShortName : '',

      isSupplier: false,
      isAdmin: false,

      keyword:"",
      supplierFullName:'',

      interval: null,

      notifications: [],
      notificationsCount: 0,
      messagesCount: 0,
      notifPage: 1,
      notifPageSize: 3,

      messageNotificationsCount: 0,
      messageNotifPage: 1,
      messageNotifPageSize: 3,

      role:null,
    };
      },
  components: { simplebar, PaymentStoryModal },
  created() {
    this.getNotifications() // first run
    this.interval = setInterval(this.getNotifications, 300000)
    this.role=sessionStorage.getItem("userr");

  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.role = sessionStorage.getItem("userr")

     if (sessionStorage.getItem("userFullName") != null) {
      this.userFullName = sessionStorage.getItem("userFullName");
      this.userShortName = this.userFullName != null ? this.userFullName.split(' ')[0] : '';
    }
    
    this.isSupplier = sessionStorage.getItem("userr") == 1;
    this.isAdmin = sessionStorage.getItem("userr") == 2;

    if (this.isSupplier) {
      this.getSupplierName();
    }
    



  },
  methods: {
    getSupplierName(){
      SupplierApi.getName().then(
        name =>{
          this.supplierFullName=name;
        }
      )
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.lan = locale;
      this.text = country;
      i18n.locale = locale;
    },

    search() {
      this.$router.push({ name: 'Recherche', query: { keyword: this.keyword } })
    },

    getNotifications() {

      NotificationsApi.getNotifications(this.notifPage -1 ,this.notifPageSize)
      .then(notif => {
        if (notif) {
          this.notifications = notif.notifications;
          this.notificationsCount = notif.count;
          this.messagesCount = notif.messagesCount;
        }
      })
    },

    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        case 4 : return "fas fa-file-invoice-dollar";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-primary";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        case 4: return "bg-primary";
        default : return "bg-secondary";
      }
    },

    toPath(notificationType){
      if (notificationType == null) {
        return;
      }
      if(notificationType==0 || notificationType==1 || notificationType==2 || notificationType==3){
        return '/orders/order'
      }

      if(notificationType==4){
        return '/invoices/list'
      }
    },

    toQuery(notif){
      if (notif == null) {
        return;
      }
      if(notif.type==0 || notif.type==1 || notif.type==2 || notif.type==3){
        return notif.orderId
      }

      if(notif.type==4){
        return null
      }
    },
  },
};
</script>

<style>
  .navbar-header .dropdown.show .header-item {
    background-color: #297a54
}

    @media all and (max-width: 1024px) and (min-width: 1024px) {
    #logo {
        padding-left: 20px;
    } 

    }

</style>

<template>  
  <header id="page-topbar">
    <div class="navbar-header" >
      <div class="d-flex">
        <!-- LOGO -->
        <!-- <div class="navbar-brand-box" style="background-color: white  !important; ">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="80" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="80" />
            </span>
          </router-link>
        </div> -->

        <div class="navbar-brand-box pl-lg-0  d-none d-md-inline">
          <!-- <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link> -->

          <router-link to="/" class="logo  " id="logo" >
            <span class="logo-sm d-none d-md-inline d-lg-none ">
              <img class="ml-2" src="@/assets/images/logo-dark.png" alt height="35" />
            </span>
            <span class="logo-lg">

              <img class="ml-2" src="@/assets/images/logo-dark.png" alt height="35" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item d-md-none"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars" style="color: #297a54; font-size: 25px;"></i>
        </button>

        <!-- App Search-->
        <!-- <b-form v-on:submit.prevent="" class="app-search d-none d-lg-block" v-if="this.role==0">
          <div class="position-relative">
            <b-input type="text" class="form-control" v-model="keyword" :placeholder="$t('navbar.search.text')" @keyup.native.enter="search()"/>
            <span class="bx bx-search-alt"></span>
          </div>
        </b-form> -->
        
          
        
      </div>

      <div class="d-flex">

        <!-- <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item text-white"
          
          v-if="this.isSupplier"
        >
        <span class="font-size-16 font-weight-bold" style="border: 2px solid white;border-radius: 18px;padding: 6px; background-color:#393f4f;" >{{this.supplierFullName}}</span>
        
        </button> -->

        <!-- App Search-->
        <b-form v-on:submit.prevent="" class="app-search d-none d-lg-block" v-if="this.role==0">
          <div class="position-relative">
            <b-input type="text" class="form-control text-primary" style="border:2px solid white;font-weight:bold;" v-model="keyword" :placeholder="$t('navbar.search.text')" @keyup.native.enter="search()"/>
            <span class="bx bx-search-alt text-primary"></span>
          </div>
        </b-form>

        <b-dropdown   
        :class="isSupplier ? 'd-none' : 'd-inline-block d-lg-none ml-2'"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify font-size-26 text-white"></i>
          </template>

          <form v-on:submit.prevent="" class="p-3" v-if="this.role==0">
            <div class="form-group m-0">
              <div class="input-group">
                <b-input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                  v-model="keyword"
                  @keyup.native.enter="search()"

                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit" @click="search()">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>



        <b-dropdown v-if="this.role != 1"
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <router-link to="/messages" class="header-item noti-icon">
              <i class="bx bx-chat text-primary" style="font-size:25px;"></i>
              <span
                class="badge badge-success badge-pill" :class="messagesCount == 0 ? 'd-none' : ''"
              >{{messagesCount}}</span>
            </router-link>
          </template>
        </b-dropdown>





        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell text-primary" style="font-size:25px;"></i>
            <span
              class="badge badge-success badge-pill" :class="notificationsCount == 0 ? 'd-none' : ''"
            >{{notificationsCount}}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ $t('navbar.dropdown.notification.text')}}</h6>
              </div>
              <div class="col-auto">
                <!-- <a href="#" class="small">{{ $t('navbar.dropdown.notification.subtext')}}</a> -->
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px;">
            
            <div v-for="notif in notifications" :key="notif.id">
              <router-link :to="{ path:toPath(notif.type), query: { orderId:  toQuery(notif) }}">
                <a href="javascript: void(0);" class="text-reset notification-item">
                  <div class="media">
                    <div class="avatar-xs mr-3">
                      <span class="avatar-title rounded-circle font-size-16" :class="toNotificationColor(notif.type)">
                        <i :class="toNotificationIcon(notif.type)"></i>
                      </span>
                    </div>
                    <div class="media-body">
                      <h6 class="mt-0 mb-1">{{notif.message}}</h6>
                      <div class="font-size-12 text-muted">
                        <!-- <p class="mb-1">Nouvelle commande</p> -->
                        <p class="mb-0">
                          <i class="mdi mdi-clock-outline"></i>
                          {{ notif.date }}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </router-link>

            </div>
          </simplebar>
          <div class="p-2 border-top">
            <div class="row">

            <div class="col-2">
                 <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage <= 1 ? 'd-none' : ''" @click="notifPage--; getNotifications();"  href="javascript:void(0)">
                    <i class="fas fa-backward text-left" ></i>    
                </a>

              </div>

            <div class="col-8 text-center pt-1">
              <span class="mr-2 ml-2 text-muted font-weight-bold" :class="notifPage == 1 ? 'd-none': ''">Page {{notifPage}}</span>
            </div>

              <div class="col-2">
                 <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage >= notifPagesNbr ? 'disabled' : ''" href="javascript:void(0)" @click="notifPage++; getNotifications();">
                  <i class="fas fa-forward text-right" ></i>
                    
                </a>

              </div>
              
            </div>

          </div>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/avatar-1.jpg"
              alt="Header Avatar"
            />
            <!-- <span class="d-none d-xl-inline-block ml-1 text-primary" style="font-size:15px;font-weight:bold;">{{userShortName}} {{isSupplier ? ' - ' + supplierFullName : ''}} {{isAdmin ? ' - ADMIN' : ''}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-primary" style="font-size:15px;"></i> -->
          </template>
          <!-- item-->
          <b-dropdown-item>

            <router-link tag="span" to="/profil">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t('navbar.dropdown.henry.list.profile') }} de {{userFullName}}
            </router-link>
          </b-dropdown-item>
           
            <b-dropdown-item v-if="role==0" >
              <router-link tag="span" to="/payment" class="text-dark font-weight-bold" >
                <i class="fas fa-credit-card font-size-16 align-middle mr-1"></i>
                Forfaits LGP
              </router-link>
            </b-dropdown-item>       

          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.henry.list.logout') }}
          </a>
        </b-dropdown>

      </div>
    </div>

    <span class="text-danger">
</span>

    <PaymentStoryModal/>

  </header>
</template>


<style scoped>

.form-control{
  background-color: #f8f8f8 !important;
}

::v-deep.app-search .form-control::placeholder {
  color: #000 !important;
  font-weight: 200;
  opacity: 1;
}
::v-deep.app-search .form-control {
  height: 40px;
}

</style>